var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data.sputum_culture)?_c('fragment',[_c('td',[_vm._v(_vm._s(_vm.done))]),_c('td',[_vm._v(_vm._s(_vm.data.sputum_culture.date))]),_c('td',[_vm._v(_vm._s(_vm.result))])]):_c('fragment',[_c('td',[_vm._v("-")]),_c('td',[_vm._v("-")]),_c('td',[_vm._v("-")])])
}
var staticRenderFns = []

export { render, staticRenderFns }